import { render, staticRenderFns } from "./ResponsibilityAssignmentsTable.vue?vue&type=template&id=6fd3aa74&scoped=true"
import script from "./ResponsibilityAssignmentsTable.vue?vue&type=script&lang=js"
export * from "./ResponsibilityAssignmentsTable.vue?vue&type=script&lang=js"
import style0 from "./ResponsibilityAssignmentsTable.vue?vue&type=style&index=0&id=6fd3aa74&prod&lang=css"
import style1 from "./ResponsibilityAssignmentsTable.vue?vue&type=style&index=1&id=6fd3aa74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd3aa74",
  null
  
)

export default component.exports